export const ROTINA_CONTATO = 3;
export const RESTRICAO_OCULTAR_NUMERO = 'OCULTAR_NUMERO_CELULAR';
